import loadTicketsArray from "./loadTicketsArray";
import getRandomInt from "./getRandomInt";

async function generateErrorTasksForExam(
  categoryTickets,
  errorTaskId,
  currentTicketId
) {
  currentTicketId = parseInt(currentTicketId);
  let errTasks = [];
  let randomNumber = currentTicketId - 1;
  let arrOfTicketIndexes = [currentTicketId - 1];

  const ticketsArray = await loadTicketsArray(categoryTickets);
  const ticketsLength = ticketsArray.length;
  const errTasksQuantity = 5;

  for (let i = 0; i < errTasksQuantity; i++) {
    while (arrOfTicketIndexes.includes(randomNumber)) {
      randomNumber = getRandomInt(ticketsLength);
    }
    arrOfTicketIndexes.push(randomNumber);

    errTasks.push({
      ...ticketsArray[randomNumber].tasks[errorTaskId - 1],
      ticketId: ticketsArray[randomNumber].ticketId,
    });
  }

  return errTasks;
}

export default generateErrorTasksForExam;
